const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  shippingTracking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/jyorder-share/shipping-tracking', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
